import { graphql, useStaticQuery } from "gatsby";
import React from "react";

import type { LexiconContextQuery } from "../../graphql-types";
import createCtx from "./createCtx";

type LexiconState = Omit<
  Readonly<NonNullable<LexiconContextQuery["lexicon"]>>,
  "__typename"
>;

const [useLexicon, Provider] = createCtx<LexiconState>();

const LexiconProvider: React.FC = ({ children }) => {
  const data = useStaticQuery<LexiconContextQuery>(graphql`
    query LexiconContext {
      lexicon {
        benefits
        buyItNow
        certificates
        description
        facts
        home
        howToUseHeading
        ingredients
        invalidFormatValidationMessage
        maxLengthValidationMessage
        opensInNewTab
        pageNotFoundText
        products
        ratingFormatString
        readMore
        relatedProducts
        requiredFieldValidationMessage
        reviewCountFormatString
        reviewsHeading
        share
        skipToContent
        socialTitle
      }
    }
  `);

  if (!data.lexicon) {
    throw new Error("Could not query lexicon fields");
  }

  return <Provider value={data.lexicon}>{children}</Provider>;
};

export { useLexicon, LexiconProvider };
